export function VideocamCloseFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.952 7.462l1.755-1.755a1 1 0 00-1.414-1.414l-14 14a1 1 0 101.414 1.414l.755-.755c.175.031.354.048.538.048h8a3 3 0 003-3v-1.586l4.293 4.293A1 1 0 0022 18V6a1 1 0 00-1.707-.707L16 9.586V8c0-.184-.017-.363-.048-.538zM13 5c.184 0 .363.016.538.048l-11.49 11.49A3.017 3.017 0 012 16V8a3 3 0 013-3h8z"
      ></path>
    </svg>
  );
}
